import { useEffect, useState } from "react";
import api from "../lib/api";

let cache = null;

export function usePublicConfig() {
  const [config, setConfig] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/config/public").then((r) => {
      cache = r.data;
      setConfig(r.data);
    }).catch(() => {});
  }, []);
  return config;
}
